import { z } from 'zod'

export const journalEntryLineSchema = z.object({
  JournalEntryLineDetail: z.object({
    PostingType: z.union([z.literal('Debit'), z.literal('Credit')]),
    AccountRef: z.object({
      name: z.string(),
      value: z.string(),
    }),
    Entity: z
      .object({
        Type: z.union([z.literal('Customer'), z.literal('Vendor')]),
        EntityRef: z.object({
          name: z.string(),
          value: z.string(),
        }),
      })
      .optional(),
    ClassRef: z
      .object({
        name: z.string(),
        value: z.string(),
      })
      .optional(),
    DepartmentRef: z
      .object({
        name: z.string(),
        value: z.string(),
      })
      .optional(),
  }),
  Amount: z.number(),
  Description: z.string(),
})

export type JournalEntryLine = z.infer<typeof journalEntryLineSchema>

export const journalEntrySchema = z.object({
  Id: z.string().optional(),
  RemoteId: z.string().optional(),
  TxnDate: z.string(),
  Line: z.array(journalEntryLineSchema),
  PrivateNote: z.string(),
  MetaData: z
    .object({
      CreateTime: z.string(),
    })
    .optional(),
  PostingStatus: z.string().optional(),
  RemoteData: z.any(),
})

export type JournalEntry = z.infer<typeof journalEntrySchema>
